import { useQueryWithUserId } from '@northladder/services';

import { CUSTOMER_SERVICE_API } from '../customerServiceClient';
import { IFetchTopBrandsPayload } from '../types';

/**
 * This is to track the top brands react query cached data
 */
const TOP_BRANDS_KEY = 'TOP_BRANDS_QUERY';

/**
 * this hook will call top brands customer service api and manage the cached
 * data. and it return the loading, data, error etc.. states reactQuery
 */
export const useTopBrandsQuery = (payload: IFetchTopBrandsPayload) => {
  const { by, fromDate, toDate } = payload;
  const { data, isError, error, isPending, refetch } = useQueryWithUserId({
    // eslint-disable-next-line @tanstack/query/exhaustive-deps
    queryKey: [TOP_BRANDS_KEY, by, fromDate, toDate],
    queryFn: () => CUSTOMER_SERVICE_API.fetchTopBrands(payload),
  });

  return {
    error,
    isError,
    data,
    isPending,
    refetch,
  };
};
